import _ from 'lodash';
import {
    FETCH_AUTHS,
    FETCH_AUTH,
    DELETE_AUTH,
    EDIT_AUTH,
    NEW_AUTH,
    CHECK_AUTH,
    QUIT_AUTH
} from '../actions/types';


export const authReducer = (state = {}, action) => {
    switch (action.type) {
        case FETCH_AUTHS :
            return {..._.mapKeys(action.payload, '_id')}
        case NEW_AUTH : 
            return {...state, [action.payload.id]: action.payload};
        case EDIT_AUTH : 
            return {...state, [action.payload.id]: action.payload};
        case QUIT_AUTH : 
            return action.payload; 
        case DELETE_AUTH : 
            return _.omit(state, action.payload);  
        case CHECK_AUTH : 
            return action.payload;      
        default : 
            return state;
    }
};


export const selectedAuthReducer = (selectedAuth = {}, action) => {
    if (action.type === FETCH_AUTH) {
        return action.payload;
    }

    return selectedAuth;
};

